import {
  Box,
  CircularProgress,
  Divider,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Step,
  StepIcon,
  StepIndicator,
  StepNumber,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  useSteps,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useCreateResellerCustomerModalContext } from './ModalContext';
import ContractStep from './steps/ContractStep';
import CustomerStep from './steps/CustomerStep';
import InstallationStep from './steps/InstallationStep';

const steps = [
  { title: 'Cliente' },
  { title: 'Contrato' },
  { title: 'Instalação' },
];

interface Props {
  isOpen: boolean;
  onClose(): void;
}

const CreateResellerCustomerModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const { step, setStep, loading } = useCreateResellerCustomerModalContext();
  const { activeStep, setActiveStep } = useSteps({
    index: 0,
    count: steps.length,
  });

  useEffect(() => {
    setActiveStep(step);
  }, [step, setActiveStep]);

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
      <DrawerOverlay />
      <DrawerContent pos="relative">
        <DrawerCloseButton />
        <DrawerHeader>
          Novo Cliente - Revenda
          <Divider my="1rem" />
          <Stepper index={activeStep} mt="1rem">
            {steps.map((s, idx) => (
              <Step key={s.title}>
                <StepIndicator
                  cursor={step > idx ? 'pointer' : 'default'}
                  onClick={() => step > idx && setStep(idx)}
                >
                  <StepStatus
                    complete={<StepIcon />}
                    incomplete={<StepNumber />}
                    active={<StepNumber />}
                  />
                </StepIndicator>
                <Box
                  flexShrink="0"
                  cursor={step > idx ? 'pointer' : 'default'}
                  onClick={() => step > idx && setStep(idx)}
                >
                  <StepTitle>{s.title}</StepTitle>
                </Box>
                {idx < steps.length - 1 && <StepSeparator />}
              </Step>
            ))}
          </Stepper>
        </DrawerHeader>

        {step === 0 && <CustomerStep onClose={onClose} />}
        {step === 1 && <ContractStep onClose={onClose} />}
        {step === 2 && <InstallationStep onClose={onClose} />}

        {loading && (
          <Flex
            pos="absolute"
            top="0"
            left="0"
            w="100%"
            h="100%"
            bg="gray.100"
            zIndex="1"
            align="center"
            justify="center"
          >
            <CircularProgress isIndeterminate color="yooga.400" />
          </Flex>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default CreateResellerCustomerModal;
